import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { get } from '../api/ventura/destination';
import { camelCaseKeys } from '../util/object';
import { useConfig } from './useConfig';

function useDestinations(adGroupId: number, enabled = true) {
  const { apiHost } = useConfig();
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const query = useQuery({
    queryKey: ['destinations', adGroupId, page, perPage],
    queryFn: () => get(apiHost, Number(adGroupId), { page, perPage }),
    select: camelCaseKeys,
    enabled,
  });

  return { page, setPage, perPage, setPerPage, ...query };
}

export default useDestinations;
